export const TNB_INTERNAL_OWNER_ID = "544e425f494e5445524e414c";
